<template>
  <label class="container d-flex align-center">
    <div>{{ label }}</div>
    <input type="checkbox" :readonly="readonly" :checked="checked" :value="value" @change="$emit('change', $event.target.checked)"/>
    <span class="checkmark"></span>
    <slot name="checkbox-label" />
  </label>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
}
</script>

<style lang="scss" scoped>
/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 51px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1.38;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
/* Create a custom checkbox */
.checkmark {
  position: absolute;
  left: 0;
  height: 32px;
  width: 32px;
  background-color: #fff;
  border: solid 1px var(--apio-shade-4);
  border-radius: 4px;
}
// /* On mouse-over, add a grey background color */
// .container:hover input ~ .checkmark {
//   background-color: #ccc;
// }
/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: var(--apio-purple);
  border-color: var(--apio-purple);
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}
/* Style the checkmark/indicator */
.container .checkmark:after {
  display: inline-block;
  transform: rotate(45deg);
  height: 13px;
  width: 7px;
  border-bottom: 2px solid white;
  border-right: 2px (--borderWidth) solid white;
  left: 12px;
  top: 7px;
}
</style>